"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    stepTitle: {
        id: 'registration.personalDetails.stepTitle',
        defaultMessage: 'Your details',
        description: 'Registration personal details step title',
    },
    title: {
        id: 'registration.personalDetails.title',
        defaultMessage: 'Your details',
        description: 'Registration personal details title',
    },
    description: {
        id: 'registration.personalDetails.description',
        defaultMessage: 'Please enter your first and last name.',
        description: 'Registration personal details description',
    },
    nameFormatValidation: {
        id: 'registration.personalDetails.validations.nameFormat',
        defaultMessage: 'Please check the name format',
        description: 'Registration personal details name format validation',
    },
});
exports.default = messages;
